// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202603231003/js/" + chunkId + "." + {"44":"2830a15e","225":"ba88e303","481":"45fd817f","486":"af1efcf2","770":"2091c491"}[chunkId] + ".0.5903928564444079.chunk.js";
};